/**
 * Drop-in replacement for React Native's `Modal` with default `supportedOrientations`
 * (iOS can force portrait when it is omitted).
 *
 * **Use this** when you need the core RN modal (`visible`, `transparent`, `animationType`, …).
 *
 * **Do not use** for `@constants/Themed` `Modal` — that component is `react-native-modal`
 * (`isVisible`, `setVisible`, `extraChildren`, …). Import `Modal` from `@constants/Themed` instead.
 *
 * Explicit `supportedOrientations` on this component still wins over the default (`??`).
 */
import React, { forwardRef } from 'react';
import { Modal as RNModal } from 'react-native';
import { MODAL_SUPPORTED_ORIENTATIONS } from '@constants/modalSupportedOrientations';

export const Modal = forwardRef<
  React.ElementRef<typeof RNModal>,
  React.ComponentProps<typeof RNModal>
>(function ModalWithDefaultOrientations(props, ref) {
  const { supportedOrientations, ...rest } = props ?? {};
  return (
    <RNModal
      ref={ref}
      {...rest}
      supportedOrientations={
        supportedOrientations ?? [...MODAL_SUPPORTED_ORIENTATIONS]
      }
    />
  );
});
